import Vue from "vue";

import "core-js/stable";
import "regenerator-runtime/runtime";

import axios from "axios";
import {
    TablePlugin,
    TableSimplePlugin,
    FormPlugin,
    FormInputPlugin,
    InputGroupPlugin,
    FormSelectPlugin,
    FormGroupPlugin,
    FormRadioPlugin,
    FormCheckboxPlugin,
    FormTextareaPlugin,
    FormTagsPlugin,
    LayoutPlugin,
    NavPlugin,
    ListGroupPlugin,
    AlertPlugin,
    BadgePlugin,
    ButtonPlugin,
    CardPlugin,
    TooltipPlugin,
    CollapsePlugin
} from "bootstrap-vue";
import collectjs from "collect.js";
import Clipboard from "v-clipboard";
import VueNotifications from "vue-notification";
import VueModal from "vue-js-modal";
import VueMultiselect from "vue-multiselect";
import Vuelidate from "vuelidate";
import VueSweetalert2 from "vue-sweetalert2";
import VueScrollTo from "vue-scrollto";
import VueProgressBar from "vue-progressbar";
import ToggleButton from "vue-js-toggle-button";
const VueQrcode = () => import("@chenfengyuan/vue-qrcode");
import moment from "moment";

import { library } from "@fortawesome/fontawesome-svg-core";
// prettier-ignore
import { faBars, faBug, faLink, faSpinner, faBan, faCheck, faCopy, faTimes, faShoppingCart, faComments, faBirthdayCake, faToolbox, faSearch, faEdit, faCode, faArrowDown, faArrowUp, faCaretLeft, faEye, faUpload, faSync} from "@fortawesome/free-solid-svg-icons";
// prettier-ignore
import { faInfoSquare, faExclamationSquare, faCheckSquare, faTimesSquare, faClone, faPlusSquare, faWindowRestore, faSave, faUsers, faServer, faCubes, faCog, faEllipsisV, faLock, faInfinity, faLockAlt, faLockOpenAlt } from "@fortawesome/pro-regular-svg-icons";
import { faLaravel, faWordpress, faDrupal, faYelp, faJoomla, faWikipediaW } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// config
import certificates from "./config/certificates";

import Loader from "./components/Loader.vue";
import CcsModal from "./components/CcsModal.vue";

import App from "./app.vue";
import router from "./router";
import store from "./store";
import laroute from "./laroute";
import generatePassword from "@/helpers/PasswordGenerator";

Vue.use(TablePlugin);
Vue.use(TableSimplePlugin);
Vue.use(FormPlugin);
Vue.use(FormInputPlugin);
Vue.use(InputGroupPlugin);
Vue.use(FormSelectPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormRadioPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(FormTagsPlugin);
Vue.use(LayoutPlugin);
Vue.use(NavPlugin);
Vue.use(ListGroupPlugin);
Vue.use(AlertPlugin);
Vue.use(BadgePlugin);
Vue.use(ButtonPlugin);
Vue.use(CardPlugin);
Vue.use(TooltipPlugin);
Vue.use(CollapsePlugin);

Vue.use(VueNotifications, { componentName: "vue-notifications" });
Vue.use(VueModal, { dialog: true, dynamic: true });
Vue.use(Vuelidate);
Vue.use(ToggleButton);
Vue.use(VueSweetalert2);
Vue.use(VueScrollTo);
Vue.use(VueProgressBar, {
    color: "#37bc9b",
    failedColor: "#ff5454",
    thickness: "5px",
    transition: {
        speed: "0.2s",
        opacity: "0.6s",
        termination: 300,
    },
    location: "top",
});
Vue.use(Clipboard);

// prettier-ignore
library.add(faBars, faBug, faLink, faSpinner, faInfoSquare, faBan, faLaravel,
    faWordpress, faExclamationSquare, faCheck, faCheckSquare, faTimesSquare, faCopy,
    faTimes, faDrupal, faShoppingCart, faComments, faYelp, faBirthdayCake, faToolbox,
    faJoomla, faPlusSquare, faSearch, faClone, faWindowRestore, faEdit, faSave, faWikipediaW,
    faCode, faArrowDown, faArrowUp, faUsers, faServer, faCubes, faCog, faEllipsisV, faLock, faInfinity,
    faCaretLeft, faEye, faLockAlt, faLockOpenAlt, faUpload, faSync
);

Vue.component("multiselect", VueMultiselect);
Vue.component("fa", FontAwesomeIcon);
Vue.component("loader", Loader);
Vue.component("ccs-modal", CcsModal);
Vue.component(VueQrcode.name, VueQrcode);

Vue.prototype.$axios = axios;
Vue.prototype.$laroute = laroute;
Vue.prototype.$collect = collectjs;
Vue.prototype.$generatePassword = generatePassword;
Vue.prototype.$moment = moment;

Vue.prototype.$config = {
    certificates: certificates
};


new Vue({
    el: "#app",
    router,
    store,
    render: (h) => h(App),
    data: {
        weekDays: [
            'ignore',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
            'Sunday',
        ],
        ccs_constants: {
            BACKUP_TYPE_SERVER: "91001",
            BACKUP_TYPE_REPO: "91002",
            BACKUP_TYPE_STORAGE_LOCATION: "91003",

            BACKUP_DATABASE_MODE_NONE: "120001",
            BACKUP_DATABASE_MODE_ALL: "120002",
            BACKUP_DATABASE_MODE_ONLY_LISTED: "120003",
            BACKUP_DATABASE_MODE_EXCEPT_LISTED: "120004",

            BACKUP_EMAIL_MODE_NONE: "132001",
            BACKUP_EMAIL_MODE_ALL: "132002",
            BACKUP_EMAIL_MODE_ONLY_LISTED: "132003",
            BACKUP_EMAIL_MODE_EXCEPT_LISTED: "132004",

            DATABASE_HOST_TYPE_LOCAL_CLUSTER_HOST: "49001",
            DATABASE_HOST_TYPE_ANY: "49003",

            ENTITY_TYPE_CLUSTER: "69001",
            ENTITY_TYPE_SINGLE_SERVER: "69002",

            BACKUP_REPO_TYPE_FTP: "126001",
            BACKUP_REPO_TYPE_AMAZON_S3: "126002",

            BACKUP_REPO_FTP_TYPE_FTP: "126501",
            BACKUP_REPO_FTP_TYPE_FTPS: "126502",

            BACKUP_SCHEDULE_JUST_NOW: "190001",
            BACKUP_SCHEDULE_REGULAR: "190002",

            BACKUP_SCHEDULE_REGULAR_DAILY: "200001",
            BACKUP_SCHEDULE_REGULAR_WEEKLY: "200002",
            BACKUP_SCHEDULE_REGULAR_MONTHLY: "200003",
        }
    }
});
